export enum AdviceNeededInfo {
  DonationInterest = 'info-donation-interest',
  DonatationNoInterest = 'info-donation-no-interest',
  VerhicleOtherInterest = 'verhicle-other-interest'
}
